import { useState } from "react";
import { Row, Col, Drawer, message } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  Label,
  Outline,
} from "./styles";
import styled from "styled-components";
import { LogOut } from "lucide-react";

const LogoutButton = styled.button`
  background: linear-gradient(135deg, #ff4d4f, #d9363e);
  border: none;
  border-radius: 30px;
  padding: 8px 20px;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: linear-gradient(135deg, #ff7875, #ff4d4f);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(217, 54, 62, 0.35);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const LogoutButtonDrawer = styled(LogoutButton)`
  width: 100%;
  justify-content: center;
  margin-top: 1.5rem;
`;

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const handleLogout = async () => {
    try {
      const res = await fetch("https://kevhel.com/api/logout.php", {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();

      if (data.success) {
        message.success("Sesión cerrada correctamente");
        setTimeout(() => {
          window.location.href = "/"; 
        }, 1500);
      } else {
        message.error("Error al cerrar sesión");
      }
    } catch (err) {
      console.error(err);
      message.error("Error al conectar con el servidor");
    }
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between" align="middle">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="unnamed.svg" width="101px" height="64px" />
          </LogoContainer>

          <NotHidden>
            <LogoutButton onClick={handleLogout}>
              <LogOut /> Cerrar sesión
            </LogoutButton>
          </NotHidden>

          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>

        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>

          <LogoutButtonDrawer onClick={handleLogout}>
            <LogOut /> Cerrar sesión
          </LogoutButtonDrawer>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);